import type { Device, OrganizationDto } from "@strtmn/sds/types"

export interface MinimalMachineEntry {
  vin: string | undefined
}

export const getLinkToEuDataActTerms = (
  termsVersion: string,
  userPrefLang: string
) => {
  const availableTranslations = ["de"]
  const DefaultLanguage = "de"
  const lang = availableTranslations.includes(userPrefLang)
    ? userPrefLang
    : DefaultLanguage
  return `/terms/eu-data-act/DNV_${termsVersion}_${lang}.pdf`
}

export const getLinkToVehicleOverview = (vehicle: MinimalMachineEntry) => {
  // This function has maschine by design.
  // This way, we can switch links from internal to external serial numbers in the future.
  return `/vehicles/${vehicle.vin}/`
}
export const getLinkToVehicleCanTraces = (vehicle: MinimalMachineEntry) => {
  // This function has maschine by design.
  // This way, we can switch links from internal to external serial numbers in the future.
  return `/vehicles/${vehicle.vin}/can-traces/`
}
export const getLinkToVehicleDebug = (vehicle: MinimalMachineEntry) => {
  // This function has maschine by design.
  // This way, we can switch links from internal to external serial numbers in the future.
  return `/vehicles/${vehicle.vin}/debug/`
}
export const getLinkToVehicleReport = (vehicle: MinimalMachineEntry) => {
  // This function has maschine by design.
  // This way, we can switch links from internal to external serial numbers in the future.
  return `/vehicles/${vehicle.vin}/report/`
}
export const getLinkToVehicleEuDataAct = (vehicle: MinimalMachineEntry) => {
  // This function has maschine by design.
  // This way, we can switch links from internal to external serial numbers in the future.
  return `/vehicles/${vehicle.vin}/eu-data-act/`
}
export const getLinkToVehicleDataDownloadOverview = (
  maschine: MinimalMachineEntry
) => `${getLinkToVehicleEuDataAct(maschine)}raw-data/`
export const getLinkToVehicleDataDownload = (
  maschine: MinimalMachineEntry,
  dateOfReport: string
) => `${getLinkToVehicleDataDownloadOverview(maschine)}${dateOfReport}/`
export const getLinkToEuDataActTransfer = (maschine: MinimalMachineEntry) =>
  `${getLinkToVehicleEuDataAct(maschine)}transfer/`
export const getLinkToEuDataActDataSharing = (maschine: MinimalMachineEntry) =>
  `${getLinkToVehicleEuDataAct(maschine)}data-sharing/`

export const getLinkToTimeseries = (
  vin: string,
  pgn: string,
  sourceAddress: string,
  spn: string
) => {
  if (!sourceAddress) {
    sourceAddress = "0"
  }
  return `/vehicles/${vin}/history/${encodeURIComponent(pgn)}/${encodeURIComponent(sourceAddress)}/${encodeURIComponent(spn)}/`
}
export const getLinkToDtcTimeseries = (vin: string) => {
  return `/vehicles/${vin}/history/dtcs/`
}
export const getLinkToModem = (vehicle: Device) => {
  // This function has maschine by design.
  // This way, we can switch links from internal to external serial numbers in the future.
  return `/modems/${vehicle.modem_sn}/`
}

export const getLinkToOrgs = () => "/orgs/"
export const getLinkToOrg = (org: OrganizationDto, editMode: boolean) =>
  getLinkToOrgById(org.id, editMode)
export const getLinkToOrgById = (orgId: string, editMode: boolean) =>
  `/orgs/${orgId}` + (editMode ? "/edit" : "")
export const getLinkToLinkMachine = (orgId: string) =>
  `/orgs/${orgId}/link-machine`
export const getLinkToOrgRecipes = (org: OrganizationDto) =>
  `/orgs/${org.id}/recipes/`
export const getLinkToOrgRecipe = (
  org: OrganizationDto,
  recipeId: string,
  editMode: boolean
) => `${getLinkToOrgRecipes(org)}${recipeId}` + (editMode ? "/edit" : "")
export const getLinkToOrgRations = (org: OrganizationDto) =>
  `/orgs/${org.id}/rations/`
export const getLinkToOrgFeedComponents = (org: OrganizationDto) =>
  `/orgs/${org.id}/feed-components/`
export const getLinkToOrgFeedComponent = (
  org: OrganizationDto,
  feedComponentId: string,
  editMode: boolean
) =>
  `${getLinkToOrgFeedComponents(org)}${feedComponentId}` +
  (editMode ? "/edit" : "")
export const getLinkToOrgAnimalGroups = (org: OrganizationDto) =>
  `/orgs/${org.id}/animal-groups/`
export const getLinkToOrgAnimalGroup = (
  org: OrganizationDto,
  animalGroupId: string,
  editMode: boolean
) =>
  `${getLinkToOrgAnimalGroups(org)}${animalGroupId}` + (editMode ? "/edit" : "")
// export const getLinkToOrgRations = (org: OrganizationDto) => `/orgs/${org.id}/rations/`
